export const __ACCOUNTS_URL_BASE__ = `//${location.host.replace(/^markup\./, 'accounts.')}`
